export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4086a1ef87a73481d7cc4999486f87a64bc937f3ef&name=revalidateCommunity!'